import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { MenuButton } from '@reach/menu-button';
import '@reach/menu-button/styles.css';
import PropTypes from 'prop-types';

import { FAIcon } from 'lib/customPropTypes';

import { Icon } from '../Icons';

import './styles/iconDropdownButtonStyles.css';

// This component is deprecated in favor of the <MenuButton/> from the __pds folder

const IconDropdownButton = ({
  ariaLabel,
  disabled,
  icon,
  isLoading,
  size,
  ...rest
}) => {
  const menuIcon = isLoading ? faSpinnerThird : icon;
  return (
    <MenuButton
      aria-label={ariaLabel}
      className="icon-dropdown-button"
      disabled={disabled || isLoading}
      {...rest}
    >
      <Icon aria-hidden icon={menuIcon} size={size} spin={isLoading} />
    </MenuButton>
  );
};

IconDropdownButton.defaultProps = {
  disabled: false,
  isLoading: false,
  size: '2x',
};

IconDropdownButton.propTypes = {
  /**
   * ARIA label that describes the purpose of this button
   */
  ariaLabel: PropTypes.string.isRequired,
  /**
   * Whether the button is in a disabled state or not
   */
  disabled: PropTypes.bool,
  /**
   * Which icon will the button be
   */
  icon: FAIcon.isRequired,
  /**
   * Whether the button is in a loading state or not
   */
  isLoading: PropTypes.bool,
  /**
   * Size of the icon
   */
  size: PropTypes.oneOf([
    'xs',
    'sm',
    'lg',
    '2x',
    '3x',
    '4x',
    '5x',
    '6x',
    '7x',
    '8x',
    '9x',
    '10x',
  ]),
};

export default IconDropdownButton;
